import Debug from 'debug'
import mqtt, { mqttSub, mqttUnsub } from 'utils/mqtt'
import { MARKET_TYPE, SEC_TYPE } from 'const/stock'
import isEqual from 'lodash/isEqual'
import bus from 'src/eventbus'
import getLocalFixedQuoteDetail from 'utils/getLocalFixedQuoteDetail'

export const weight = 20
const $debug = Debug('app:pipe-stock')

/**
 * 删除两个数组的交集元素
 * @param {array} arr1 - 数组1
 * @param {array} arr2 - 数组2
 * @returns {*[]}
 */
function removeArrMixedElements(arr1, arr2) {
  // 如果某一条数据为空则无交集，直接返回
  arr1 = arr1 || []
  arr2 = arr2 || []
  if (arr1.length === 0 || arr2.length === 0) {
    return [arr1, arr2]
  }
  const set1 = new Set(arr1)
  const set2 = new Set(arr2)
  set1.forEach(value => {
    if (set2.has(value)) {
      set1.delete(value)
      set2.delete(value)
    }
  })
  return [[...set1], [...set2]]
}

/**
 * 筛选出美股正股的标的名称
 * @param {array} stocks - 股票行情列表
 */
function filterUSSTKSymbols(stocks) {
  return (stocks || []).reduce((acc, cur) => {
    if (cur.secType === SEC_TYPE.STK && cur.market === MARKET_TYPE.US) {
      acc.push(cur.symbol)
    }
    return acc
  }, [])
}

/**
 * 订阅基本行情
 * @param {string} id - 订阅的ID
 * @param {string[]} oldSymbols - 前一个标的列表
 * @param {string[]} newSymbols - 新的标的列表
 * @param {string} [type] - 订阅类型 simple/detail
 */
function subscribeMqttQuote(id, oldSymbols, newSymbols, type = 'simple') {
  // FIXME: 计算数据如果是对象比对会一直触发更新，临时处理数据比对。
  if (isEqual(oldSymbols, newSymbols)) return
  const [s1, s2] = removeArrMixedElements(oldSymbols, newSymbols)
  $debug(`[${id}]: subscribe stocks`, s2)
  s2.forEach(symbol => {
    mqttSub(id, {
      name: 'quote',
      symbol: symbol,
      type: type
    })
  })
  $debug(`[${id}]: unsubscribe stocks`, s1)
  s1.forEach(symbol => {
    mqttUnsub(id, {
      name: 'quote',
      symbol: symbol,
      type: type
    })
  })
}

export default function(store) {
  // 订阅自选长连接
  store.watch(
    (state, getters) => {
      return filterUSSTKSymbols(getters.watchListAll)
    },
    (n, o) => {
      subscribeMqttQuote('watchListStocks', o, n)
    }
  )

  // 订阅自选持仓长连接
  store.watch(
    (state, getters) => {
      return filterUSSTKSymbols(getters.watchListHoldings)
    },
    (n, o) => {
      subscribeMqttQuote('watchListHoldingStocks', o, n)
    }
  )

  // 订阅个股顶部Tab股票行情长连接
  store.watch(
    (state, getters) => {
      const { type, list } = state.views
      const activeStock = getters.activeStock
      if (type === 1) {
        if (activeStock) return filterUSSTKSymbols([activeStock])
      } else {
        return filterUSSTKSymbols(list)
      }
      return []
    },
    (n, o) => {
      subscribeMqttQuote('quoteMainTradeStocks', o, n, 'detail')
    }
  )

  // 订阅侧边栏长连接
  store.watch(
    (state, getters) => {
      if (
        getters.activeSideStock &&
        getters.activeSideStock.secType === SEC_TYPE.STK
      ) {
        return [getters.activeSideStock.symbol]
      }
    },
    (n, o) => {
      subscribeMqttQuote('activeSideStock', o, n, 'detail')
    }
  )

  store.watch(
    (state, getters) => {
      return getters.mqttConnected
    },
    connected => {
      if (connected) {
        // 先移除旧监听器，避免重连时重复注册
        if (mqtt.off) mqtt.off('update.quote', quoteUpdateHandler)
        mqtt.on('update.quote', quoteUpdateHandler)
      }
    }
  )
  // 处理行情消息
  function quoteUpdateHandler({ data, topic }) {
    $debug('on receive quote:', data)
    if (data) {
      const type = topic.split('/').pop()
      // FIXME: 基础行情才会触发更新
      if (type === 'detail' || type === 'simple') {
        const updates = getLocalFixedQuoteDetail(data)
        updates.serverTime = updates.serverTime || updates.timestamp
        updates.source = 'mqtt'
        updates.sourceType = `quote.${type}`

        $debug('on receive stock updates: %s %o', updates.symbol, updates)
        store.dispatch('whenStockUpdate', updates)
        bus.emit(bus.$events.STOCK_UPDATE, updates)
      }
    }
  }
}
